import styled from '@emotion/styled';

interface HeroSectionContainerProps {
  isSignedIn: boolean;
  translateY?: string;
}

export const HeroSectionContainer = styled('div')<HeroSectionContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 20px;
  padding: 0;
  background: transparent;
  border-radius: 0;
  margin: 0;
  width: 100%;

  .hero-image {
    height: auto;
    border-radius: 0;
    box-shadow: none;
    align-self: center;
    position: relative;
    transform: translateY(${({ translateY }) => translateY || '0%'});
    margin: 0 auto;
  }
`;
